var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info"},[(
      this.routeQuery.clubtype == 'club' || this.routeQuery.clubtype == 'team'
    )?_c('bread-list-new',{attrs:{"routeQuery":_vm.routeQuery}}):_c('bread-list',{attrs:{"routeQuery":_vm.routeQuery}}),_c('article-template')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }